<ng-container [formGroup]="searchForm">

  <div class="row">
    <!-- Raum-/Gerätenummer -->
    <app-form-group formControlName="number" id="inputRoomNumber" name="roomNumber" class="col-sm-6" type="text"
      [text]="numberCaption" [subtext]="numberSubCaption">
    </app-form-group>
    <!-- Datum -->
    <app-form-group formControlName="date" id="inputReservationDate" name="reservationDate" class="col-sm-6" type="date"
      [placeholder]="dateFormat" text="{{'DATE'|translate}}">
    </app-form-group>
    <ng-content></ng-content>
  </div>

  <div class="custom-control custom-checkbox">
    <input type="checkbox" formControlName="showAvailable" class="custom-control-input" id="onlyAvailable"
      [checked]=searchForm.value.showAvailable>
    <label class="custom-control-label" for="onlyAvailable">{{checkboxCaption}}</label>
  </div>

  <div class="ml-4" *ngIf="searchForm.value.showAvailable">
    <!-- Dauer in Stunden -->
    <div class="custom-control custom-radio custom-control-inline form-inline">
      <input formControlName="showAvailableType" type="radio" id="availabilityModeAbsolut" class="custom-control-input"
        value="span">
      <label class="custom-control-label mr-2" for="availabilityModeAbsolut">{{'DURATION_IN_H'|translate}}</label>
      <select formControlName="showAvailableHours" class="form-control my-1" id="inlineFormCustomSelectPref"
        style="width: 90px;">
        <option *ngFor="let t of timeSpanDropdown" [value]="t.key">{{t.value}}</option>
      </select>
    </div>

    <br />

    <!-- Zeit von/bis -->
    <div class="custom-control custom-radio custom-control-inline form-inline">
      <input formControlName="showAvailableType" type="radio" id="availabilityModeSpan" class="custom-control-input"
        value="abs">
      <label class="custom-control-label mr-2" for="availabilityModeSpan">{{'TIMESPAN_START'|translate}}
      </label>
      <select formControlName="showAvailableTimeFrom" class="form-control my-1 mr-2" id="inlineFormCustomSelectPref"
        style="width: 90px;">
        <option *ngFor="let t of startTimes" [value]="t.key">{{t.value}}</option>
      </select>
      <label class="my-1 mr-2" for="inlineFormCustomSelectPref">{{'TIMESPAN_END'|translate}}</label>
      <select formControlName="showAvailableTimeTo" class="form-control my-1" id="inlineFormCustomSelectPref"
        style="width: 90px;">
        <option *ngFor="let t of endTimes" [value]="t.key">{{t.value}}</option>
      </select>
    </div>
  </div>
</ng-container>